<template>
    <el-dialog title="修改记录" :visible.sync="popupVisible" width="850px">
        <el-form :model="form" ref="form" :rules="rules" size="mini" class="form" label-width="80px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="赛事：" prop="leagueName">
                        <el-input placeholder="请输入赛事名称" v-model="form.leagueName"></el-input>
                    </el-form-item>
                    <el-form-item label="组别：">
                        <el-input placeholder="请输入组别名称" v-model="form.leagueGroupName"></el-input>
                    </el-form-item>
                    <el-form-item label="轮次：" prop="roundsNo">
                        <el-input type="number" placeholder="请输入轮次" v-model="form.roundsNo"></el-input>
                    </el-form-item>
                    <el-form-item label="桌号：" prop="tableNo">
                        <el-input type="number" placeholder="请输入桌号" v-model="form.tableNo"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="运动员姓名：" required label-width="160px">
                        <el-row type="flex">
                            <div>
                                <el-form-item label="东：" prop="eastName" label-width="50px" style="margin: 0;">
                                    <el-input type="text" v-model="form.eastName" :maxlength="10" style="width: 100px;"></el-input>
                                </el-form-item>
                                <el-row type="flex" justify="center">
                                    <el-button type="primary" icon="el-icon-sort" circle @click="exchange('ew')" style="margin: 18px 0;"></el-button>
                                </el-row>
                                <el-form-item label="西：" prop="westName" label-width="50px" style="margin: 0;">
                                    <el-input type="text" v-model="form.westName" :maxlength="10" style="width: 100px;"></el-input>
                                </el-form-item>
                            </div>
                            <div style="flex: none;width: 60px;">
                                <el-row type="flex" justify="center" align="middle" style="height: 100%;">
                                    <el-button type="success" icon="el-icon-sort" circle @click="exchange()" style="transform: rotate(90deg);"></el-button>
                                </el-row>
                            </div>
                            <div>
                                <el-form-item label="南：" prop="southName" label-width="50px" style="margin: 0;">
                                    <el-input type="text" v-model="form.southName" :maxlength="10" style="width: 100px;"></el-input>
                                </el-form-item>
                                <el-row type="flex" justify="center">
                                    <el-button type="primary" icon="el-icon-sort" circle @click="exchange('ns')" style="margin: 18px 0;"></el-button>
                                </el-row>
                                <el-form-item label="北：" prop="northName" label-width="50px" style="margin: 0;">
                                    <el-input type="text" v-model="form.northName" :maxlength="10" style="width: 100px;"></el-input>
                                </el-form-item>
                            </div>
                        </el-row>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close()">放 弃</el-button>
            <el-button type="primary" @click="save()">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import popup from '@/mixins/popup';
export default {
    name: 'DeckVideoDetail',
    mixins: [popup],
    data(){
        return {
            form: {
                leagueName: '',
                leagueGroupName: '',
                roundsNo: '',
                tableNo: '',
                eastName: '',
                westName: '',
                southName: '',
                northName: '',
            }
        }
    },
    computed: {
        rules(){
            let getNameRule = (label)=>{
                return [
                    {required: true, validator: (_, value, callback)=>{
                        if(!value){
                            callback(new Error(`请输入${label}姓名`));
                        }else if(value.length > 10){
                            callback(new Error('长度超出限制，最大10个字符'));
                        }else{
                            callback();
                        }
                    }
                }]
            }
            return {
                leagueName: [
                    {required: true, message: '请输入赛事名称'}
                ],
                roundsNo: [
                    {required: true, validator: (_, value, callback)=>{
                        if(value){
                            if(!Number.isInteger(+value)){
                                callback(new Error('轮次无效，请重新输入'));
                            }else{
                                callback();
                            }
                        }else {
                            callback(new Error('请输入轮次'));
                        }
                    }
                }],
                tableNo: [
                    {required: true, validator: (_, value, callback)=>{
                        if(value){
                            if(!Number.isInteger(+value)){
                                callback(new Error('桌号无效，请重新输入'));
                            }else{
                                callback();
                            }
                        }else {
                            callback(new Error('请输入桌号'));
                        }
                    }
                }],
                eastName: getNameRule('东家'),
                westName: getNameRule('西家'),
                southName: getNameRule('南家'),
                northName: getNameRule('北家'),
            }
        }
    },
    methods: {
        init(){
            this.resetForm();
            if(!this.data) return;
            let data = this.data;
            this.form = {
                leagueName: data.LeagueName,
                leagueGroupName: data.LeagueGroupName || '',
                roundsNo: data.RoundsNo,
                tableNo: data.TableNo,
                eastName: data.PlayerNames.PlayerEastName,
                westName: data.PlayerNames.PlayerWestName,
                southName: data.PlayerNames.PlayerSouthName,
                northName: data.PlayerNames.PlayerNorthName
            }
        },
        resetForm(){
            this.form = {
                leagueName: '',
                leagueGroupName: '',
                roundsNo: '',
                tableNo: '',
                eastName: '',
                westName: '',
                southName: '',
                northName: '',
            }
        },
        exchange(type){
            let {
                eastName,
                westName,
                southName,
                northName
            } = this.form;
            if(type == 'ew'){
                this.$set(this.form, 'eastName', westName);
                this.$set(this.form, 'westName', eastName);
            }else if(type == 'ns'){
                this.$set(this.form, 'southName', northName);
                this.$set(this.form, 'northName', southName);
            }else{
                this.$set(this.form, 'eastName', southName);
                this.$set(this.form, 'westName', northName);
                this.$set(this.form, 'southName', westName);
                this.$set(this.form, 'northName', eastName);
            }
        },
        save(){
            this.$refs.form.validate(valid=>{
                if(valid){
                    let loading = this.$loading({
                        text: '保存中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.8)'
                    })
                    let form = this.form;
                    let {
                        ReplayVideoId,
                        LeagueId,
                        LeagueGroupId,
                        VideoTime,
                        VideoUrl,
                        CoverUrl
                    } = this.data;
                    this.$api.SaveReplayVideo({
                        "ReplayVideo": {
                            ReplayVideoId,
                            LeagueId,
                            LeagueGroupId,
                            VideoTime,
                            VideoUrl,
                            CoverUrl,
                            "LeagueName": form.leagueName,
                            "LeagueGroupName": form.leagueGroupName,
                            "RoundsNo": form.roundsNo,
                            "TableNo": form.tableNo,
                            "PlayerNames": {
                                "PlayerEastName": form.eastName,
                                "PlayerWestName": form.westName,
                                "PlayerSouthName": form.southName,
                                "PlayerNorthName": form.northName
                            }
                        }
                    }).then(data=>{
                        loading.close();
                        if(data.Code == 0){
                            this.$message.success('修改成功');
                            this.close();
                            this.emitSuccess();
                        }
                    }).catch(()=>loading.close());
                }else{
                    this.$message.error('填写信息有误，请查看！');
                }
            })
        },
    }
}
</script>

<style>

</style>